import React, { useState } from "react";
import "../styles/Accordion.css";
import PlusIcon from "../assets/needhelp/plus.svg";
import MinusIcon from "../assets/needhelp/minus.svg";

export interface AccordionProps {
  /** The title displayed in the accordion header */
  title: string;
  /** The content to be shown when expanded */
  children: React.ReactNode;
  /** Optional: Whether the accordion is initially open */
  initiallyOpen?: boolean;
  /** Optional: Custom CSS class for the accordion */
  className?: string;
  /** Optional: Custom CSS class for the header */
  headerClassName?: string;
  /** Optional: Custom CSS class for the content */
  contentClassName?: string;
}

const AccordionComponent: React.FC<AccordionProps> = ({
  title,
  children,
  initiallyOpen = false,
  className = "",
  headerClassName = "",
  contentClassName = "",
}) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`accordion ${className}`}>
      <button
        className={`accordion-header ${headerClassName}`}
        onClick={toggleAccordion}
        aria-expanded={isOpen}
        type="button"
        style={{ backgroundColor: "#FFFFFF" }}

        // style={{ backgroundColor: !isOpen ? "#E2E2E2" : "#C3F1FF" }}
      >
        <span className="accordion-title">{title}</span>
        <img
          src={!isOpen ? PlusIcon : MinusIcon}
          className={`accordion-icon ${isOpen ? "open" : ""}`}
        ></img>
      </button>

      <div
        className={`accordion-content ${contentClassName} ${
          isOpen ? "open" : ""
        }`}
        aria-hidden={!isOpen}
      >
        <div className="accordion-content-inner">{children}</div>
      </div>
    </div>
  );
};

export default AccordionComponent;
